import { BASE_SERVER_URL } from '@/globals';

const init = () => {
  let icon: string | undefined;

  if (BASE_SERVER_URL.includes('localhost')) {
    icon = '/favicon-local.png';
  } else if (BASE_SERVER_URL.includes('dev')) {
    icon = '/favicon-dev.png';
  }
  if (!icon) return;

  const link = document.querySelector('link[rel="icon"]');
  if (!link) return;

  (link as HTMLLinkElement).href = icon;
};

export default init;
